export const List = () => import("./List.vue");
export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const Show = () => import("./Show.vue");
export const Barcode = () => import("./Barcode.vue");
export const UserIdCard = () => import("./UserIdCard.vue");
